import { OPERATORS } from './engine/filters.js'
import { MAX_RESOLVE_RULES, PREFERENCES, TIEBREAKS } from './engine/resolve.js'
import { BLANK_RULES, COMPARE_MODES } from './engine/compare.js'
import { MAX_RETAINED, PAGE_LIMIT } from './engine/limits.js'

/**
 * What /api/meta used to return. The catalogues are imported straight from the
 * engine modules, so the panels can never offer a rule the engine would reject —
 * the same single-definition guarantee the server gave, without the round trip.
 */
export const META = {
  operators: OPERATORS,
  preferences: PREFERENCES,
  tiebreaks: TIEBREAKS,
  maxResolveRules: MAX_RESOLVE_RULES,
  maxRetained: MAX_RETAINED,
  pageLimit: PAGE_LIMIT,
  compareModes: COMPARE_MODES,
  blankRules: BLANK_RULES,
}
